module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC8SURBVEhL7dJNCsIwEEDhILjzMl5DBfUUXkE9gtcSUVe69gzuxJ1/b6SEaZxE0oBu+uCjNB2mBXVtbX9pg6fhjBW6KMparslLirKWajf00ThraWiHDnzWUKkZfNZAqRMaZS2zPPDRFEdcccAEYdaymFqyTN6qB+R+DJ1+/o1PH87Rw0KdpaTmffpQhiW56vOY2PwateS/Kw/kS2R4Wd1vYZU774YIf4M7BrDKnX83wh6X6ir3qXLn236ecy9a3rOgQJYf3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-waggon-truck/dark/24.png
// module id = 2532
// module chunks = 2